import { toast } from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { PlusIcon } from '@phosphor-icons/react';
import { Formik } from 'components/form/formik';

import { useAllGeneralSettings } from '../../all-settings-context';
import { DocumentType, Language } from 'src/types/enums';
import { updateDocumentNote } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { nullthrows } from '../../../../utils/invariant';
import { DocumentTypeNames } from './constants';
import { Button } from '../../../../components/button/Button';
import { TextAreaField } from '../../../../components/textarea/TextAreaField';
import { Card } from '../../../../components/Card';
import { captureException } from '@sentry/react';

const DocumentNoteTypeSettingsPage = () => {
  const { docType: _docType } = useParams<{ docType: string }>();
  const documentType = nullthrows(_docType, 'Document type is a required route parameter') as DocumentType;
  if (!Object.values(DocumentType).includes(documentType as DocumentType)) {
    throw new Error(`Invalid document type: ${documentType}`);
  }

  const { settings } = useAllGeneralSettings();

  return (
    <div className="grid 2xl:grid-cols-2 gap-4">
      {[Language.Nl, Language.En, Language.Fr, Language.De].map((language) => {
        const content =
          settings.documentNotes.find((c) => c.language === language && c.documentType === documentType)?.content ?? '';

        return (
          <Card key={`${documentType}-${language}`} title={`${DocumentTypeNames[documentType]} - ${language}`}>
            <div>
              <div className="section-header mb-2">Inhoud</div>
              <Formik
                initialValues={{ content }}
                onSubmit={async (values) => {
                  try {
                    const { content } = values;
                    await updateDocumentNote({
                      documentType,
                      language,
                      content,
                    });
                    toast.success('Document note inhoud aangepast');
                  } catch (err: any) {
                    captureException(err);
                    toast.error('Kon document note inhoud niet aanpassen: ' + getDisplayError(err));
                  }
                }}
              >
                {({ handleSubmit, isSubmitting }) => (
                  <form onSubmit={handleSubmit}>
                    <TextAreaField labelText="Inhoud" name="content" rows={10} />

                    <Button
                      type="submit"
                      color="primary"
                      isDisabled={isSubmitting}
                      isLoading={isSubmitting}
                      iconLeft={<PlusIcon className="button-icon" />}
                    >
                      Pas document note inhoud aan
                    </Button>
                  </form>
                )}
              </Formik>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default DocumentNoteTypeSettingsPage;
